import moment from '@g4/moment-utc';
import {
  DAY_TYPE_ACTIVE,
  DAY_TYPE_AVAILABLE,
  DAY_TYPE_EMPTY,
  DAY_TYPE_SELECTED_DEPARTURE_DATE,
  DAY_TYPE_SELECTED_RETURN_DATE,
  DAY_TYPE_SELECTED_DEPARTURE_AND_RETURN_DATE,
  DAY_TYPE_BEFORE_DEPARTURE_DATE,
  DAY_TYPE_BEFORE_RAIDERS_GAME_DATE,
  DAY_TYPE_AFTER_RAIDERS_GAME_DATE,
  DAY_TYPE_RAIDERS_GAME_DAY,
} from '@g4/next-furniture/Calendar/constants/constants';

import { DEPARTING, RETURNING } from '../../../constants';

// function used to filter and map date / flight data onto the calendar days
export const getDataForDay = (date, selectedDate, monthRange, data) => {
  const lowFare = data.lowFares.find(lowFare =>
    date.isSame(moment(lowFare.date), 'date')
  );
  const { type, typeSecondary, disabled } = getDayType(
    date,
    selectedDate,
    monthRange,
    lowFare,
    data.departureDate,
    data.returnDate,
    data.direction,
    data.stadiumGame
  );
  return {
    date,
    type,
    typeSecondary,
    disabled,
    fare: lowFare?.fare,
    isRoundTrip: data.isRoundTrip,
    departureDate: data.departureDate,
    direction: data.direction,
    isLoading: data.isLoading,
  };
};

const getDayType = (
  date,
  selectedDate,
  monthRange,
  lowFare,
  departureDate,
  returnDate,
  direction,
  stadiumGame
) => {
  let type;
  let typeSecondary;
  let disabled = false;

  //get game date from localStorage
  const gameDate = stadiumGame?.date;
  // set the day type to control styling for that date
  if (!monthRange.contains(date)) {
    type = DAY_TYPE_EMPTY;
    disabled = true;
  } else if (selectedDate.isSame(date)) {
    type = DAY_TYPE_ACTIVE;
    disabled = false;
  } else if (lowFare) {
    type = DAY_TYPE_AVAILABLE;
    disabled = false;
  }

  if (moment(departureDate, 'YYYY-MM-DD').isSame(date)) {
    typeSecondary = DAY_TYPE_SELECTED_DEPARTURE_DATE;
  }

  if (
    moment(returnDate, 'YYYY-MM-DD').isSame(date) &&
    direction === RETURNING
  ) {
    typeSecondary = DAY_TYPE_SELECTED_RETURN_DATE;
  }

  if (
    moment(departureDate, 'YYYY-MM-DD').isSame(date) &&
    moment(returnDate, 'YYYY-MM-DD').isSame(date)
  ) {
    typeSecondary = DAY_TYPE_SELECTED_DEPARTURE_AND_RETURN_DATE;
  }

  if (gameDate && direction === DEPARTING && date.isAfter(gameDate)) {
    type = DAY_TYPE_BEFORE_RAIDERS_GAME_DATE;
    disabled = true;
  }

  if (
    direction === RETURNING &&
    lowFare &&
    date.isBefore(departureDate, 'day') &&
    type !== DAY_TYPE_EMPTY
  ) {
    type = DAY_TYPE_BEFORE_DEPARTURE_DATE;
    disabled = true;
  }

  if (gameDate && direction === RETURNING && date.isBefore(gameDate)) {
    type = DAY_TYPE_AFTER_RAIDERS_GAME_DATE;
    disabled = true;
  }

  if (gameDate && moment(date).isSame(moment(gameDate))) {
    type = DAY_TYPE_RAIDERS_GAME_DAY;
    disabled = true;
  }

  return { type, typeSecondary, disabled };
};
